import { Cbe, Event } from "../lusca-search-api/generated-src";

export default function removeEmpty(obj: Event | Cbe): any {
  if (Array.isArray(obj)) {
    return obj
      .filter((item) => item != null)
      .map((item) => (item === Object(item) ? removeEmpty(item) : item));
  }

  if (obj === null || obj === undefined || typeof obj !== "object") {
    return obj;
  }

  return Object.fromEntries(
    Object.entries(obj)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, v]) => v != null)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument
      .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v])
  );
}
